/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpsertCustomFieldValueMutationRequest,
  UpsertCustomFieldValueMutationResponse,
} from "../types/UpsertCustomFieldValue.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const upsertCustomFieldValueMutationKey = () =>
  [{ url: "/v1/custom-field/upsert-custom-field-value" }] as const

export type UpsertCustomFieldValueMutationKey = ReturnType<
  typeof upsertCustomFieldValueMutationKey
>

/**
 * @summary Upsert a custom field value
 * {@link /v1/custom-field/upsert-custom-field-value}
 */
export async function upsertCustomFieldValue(
  data: UpsertCustomFieldValueMutationRequest,
  config: Partial<RequestConfig<UpsertCustomFieldValueMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpsertCustomFieldValueMutationResponse,
    ResponseErrorConfig<Error>,
    UpsertCustomFieldValueMutationRequest
  >({
    method: "PUT",
    url: `/v1/custom-field/upsert-custom-field-value`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function upsertCustomFieldValueMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpsertCustomFieldValueMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = upsertCustomFieldValueMutationKey()
  return mutationOptions<
    ResponseConfig<UpsertCustomFieldValueMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpsertCustomFieldValueMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return upsertCustomFieldValue(data, config)
    },
  })
}

/**
 * @summary Upsert a custom field value
 * {@link /v1/custom-field/upsert-custom-field-value}
 */
export function useUpsertCustomFieldValue<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpsertCustomFieldValueMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: UpsertCustomFieldValueMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpsertCustomFieldValueMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? upsertCustomFieldValueMutationKey()

  const baseOptions = upsertCustomFieldValueMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpsertCustomFieldValueMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpsertCustomFieldValueMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<UpsertCustomFieldValueMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpsertCustomFieldValueMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpsertCustomFieldValueMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpsertCustomFieldValueMutationRequest },
    TContext
  >
}
